module.exports = __webpack_public_path__ + "img/form-field-dropdown.0f5fda56.svg";